<template>
  <div :class="portlet_classes" :style="portlet_styles">
    <div v-if="!nullish(title) || !nullish(icon) || !nullish(image)" :class="{'kt-portlet__head': true, 'no-gutters': noGutters}">
      <div class="kt-portlet__head-label">
        <span v-if="!nullish(icon)" class="kt-portlet__head-icon">
          <i :class="getIconClasses()" />
        </span>
        <span v-else-if="!nullish(image)" class="kt-portlet__head-icon">
          <img :src="image" style="max-width:100px; padding: 1em 1em 1em 0;">
        </span>
        <h3 v-if="!nullish(title)" class="kt-portlet__head-title">
          {{ title }} <small v-if="preCaption"> {{ preCaption }} </small> <small v-if="caption" :style="captionStyle">{{ caption }}</small>
        </h3>
      </div>
      <div class="basic-portlet-right-controls-container">
        <div class="basic-portlet-right-controls">
          <slot name="portlet_actions" />
        </div>
      </div>
    </div>
    <div class="kt-portlet__body" :class="portlet_body_classes">
      <div class="kt-portlet__content">
        <slot />
      </div>
    </div>
    <div v-if="showFooter" class="kt-portlet__foot">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null,
    },
    caption: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: false,
      default: null,
    },
    image: {
      type: String,
      required: false,
      default: null,
    },
    iconClasses: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    showFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    bordered: {
      type: Boolean,
      required: false,
      default: false,
    },
    borderClass: {
      type: String,
      required: false,
      default: null,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
    preCaption: {
      type: String,
      required: false,
      default: '',
    },
    captionStyle: {
      type: String,
      required: false,
      default: '',
    },
    noShadow: {
      type: Boolean,
      required: false,
      default: false,
    },
    noGutters: {
      type: Boolean,
      required: false,
      default: false,
    },
    portletClasses: {
      type: String,
      required: false,
      default: '',
    },
    portletBodyClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    portlet_classes() {
      const classes = ['kt-portlet'];

      if (this.bordered) {
        classes.push('kt-portlet--bordered');
      }

      if (this.borderClass) {
        classes.push(this.borderClass);
      }

      classes.push(this.portletClasses);

      return classes;
    },
    portlet_styles() {
      let styles = '';
      if (this.noShadow) {
        styles += `border-radius: 0; box-shadow:none;`;
      }
      return styles;
    },
    portlet_body_classes() {
      const classes = [];
      if (this.compact) {
        classes.push('compact-portlet');
      }

      if (this.noGutters) {
        classes.push('no-gutters');
      }

      classes.push(this.portletBodyClasses);

      return classes;
    },
  },
  methods: {
    getIconClasses() {
      if (!this.icon) {
        return null;
      }
      const classes = [this.icon];

      if (this.iconClasses) {
        classes.push(this.iconClasses);
      }

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~AssetsSass/_variables" as *;

.basic-portlet-right-controls-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .basic-portlet-right-controls {
    z-index: 2;
    cursor: default;
  }
}

.kt-portlet__head-label {
  color: map.get($ss-theme, 'hunter-grey');
  .kt-portlet__head-icon {
    i {
      color: map.get($ss-theme, 'teal-blue');
      font-size: 1em;
    }
  }
}

.compact-portlet {
  padding: 0;
}
</style>
